var version = {
    "name":      "dativery",
    "buildDateCode": "20260209-095222",
    "buildDate": "Mon Feb 09 2026 09:52:22 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260209-095222",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;